import ButtonT from '@components/tailwind-components/Button/ButtonT';
import InputWithLabelT from '@components/tailwind-components/Input/InputWithLabelT';
import type { SubflowTemplateFormDTO } from '@conversed/rest/src/contracts/subflow-templates/subflow-templates.dto';
import ErrorCodes from '@conversed/shared/src/errors/error-codes';
import type React from 'react';
import { useCallback, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useModal } from '../../../../hooks/modal/useModal';

type Props = {
  onSubmit: (data: SubflowTemplateFormDTO) => void;
};

export const SubflowTemplateData: React.FC<Props> = ({ onSubmit }) => {
  const { t } = useTranslation();
  const [isDuplicateName, setIsDuplicateName] = useState(false);
  const { handleSubmit, control } = useForm<SubflowTemplateFormDTO>({
    shouldUseNativeValidation: true,
  });
  const { hideModal } = useModal();

  const hideAndSubmit = useCallback(
    async (data: SubflowTemplateFormDTO) => {
      try {
        await onSubmit(data);
        hideModal();
      } catch (error: any) {
        if (error?.response?.data?.message === ErrorCodes.ALREADY_EXISTS) {
          setIsDuplicateName(true);
        }
      }
    },
    [onSubmit, hideModal],
  );

  return (
    <form
      className='tailwind-modal-form'
      onSubmit={handleSubmit(hideAndSubmit)}>
      <div className='tailwind-modal-body'>
        <div className='grid grid-cols-1 gap-x-6 gap-y-2'>
          <div className='col-span-1'>
            <InputWithLabelT
              type='text'
              field='name'
              placeholder={t('subflow-templates.name')}
              label={t('subflow-templates.name')}
              control={control}
              options={{
                required: t('general.validation.required'),
                onChange: () => {
                  setIsDuplicateName(false);
                },
              }}
              error={
                isDuplicateName
                  ? t('subflow-templates.duplicate-name-input-message')
                  : ''
              }
            />
          </div>
        </div>
      </div>
      <div className='tailwind-modal-footer'>
        <ButtonT
          onClick={() => hideModal()}
          type='button'
          styling='cancel'
          size='xs'
          rounding='md'>
          {t('general.buttons.cancel')}
        </ButtonT>
        <ButtonT type='submit' styling='primary' size='xs' rounding='md'>
          {t('general.buttons.save')}
        </ButtonT>
      </div>
    </form>
  );
};

export default SubflowTemplateData;
